import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/shared/utils/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-all duration-200 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50',
      // Apple-style colors: Blue when checked, gray when unchecked
      'data-[state=checked]:bg-blue-500 data-[state=unchecked]:bg-gray-300',
      // Hover states for better interaction feedback
      'hover:data-[state=checked]:bg-blue-600 hover:data-[state=unchecked]:bg-gray-400',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-5 w-5 rounded-full bg-white shadow-md ring-0 transition-all duration-200 ease-in-out',
        'data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
        // Enhanced shadow for better depth perception
        'data-[state=checked]:shadow-lg data-[state=unchecked]:shadow-sm'
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
